import { type FormatterUnit, isFormatterUnit } from "~/tools/formatter-unit";
import { ImpulseFormUnit } from "~/tools/impulse-form";
import { isStringDirty } from "~/tools/is-string-dirty";

const DEFAULT = "";

function auto(kind: undefined | "GaugeChart"): FormatterUnit {
	return kind === "GaugeChart" ? "percentunit" : "short";
}

type WidgetUnit = ImpulseFormUnit<string, null, undefined | string>;

function init(initial = DEFAULT): WidgetUnit {
	return ImpulseFormUnit(initial, {
		isInputDirty: isStringDirty,
		transform: (input) => (isFormatterUnit(input) ? input : undefined),
	});
}

const WidgetUnit = {
	default: DEFAULT,
	auto,
	init,
} as const;

export { WidgetUnit };
